import { useState } from "react";
import { supabase } from "../supabaseClient";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";

export default function Login() {
    const [form, setForm]               = useState({ email: "", password: "" });
    const [yukleniyor, setYukleniyor]   = useState(false);
    const [sifreUnuttum, setSifreUnuttum] = useState(false);
    const [resetEmail, setResetEmail]   = useState("");
    const [resetYukleniyor, setResetYukleniyor] = useState(false);
    const [resetGonderildi, setResetGonderildi] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setYukleniyor(true);
        const { error } = await supabase.auth.signInWithPassword({
            email: form.email,
            password: form.password,
        });
        if (error) {
            toast.error("Email veya şifre hatalı");
        } else {
            toast.success("Giriş başarılı!");
        }
        setYukleniyor(false);
    };

    const handleResetGonder = async (e) => {
        e.preventDefault();
        if (!resetEmail) {
            toast.error("Email adresinizi girin");
            return;
        }
        setResetYukleniyor(true);
        const { error } = await supabase.auth.resetPasswordForEmail(resetEmail, {
            redirectTo: window.location.origin + "/sifre-yenile",
        });
        if (error) {
            toast.error("Bir hata oluştu: " + error.message);
        } else {
            setResetGonderildi(true);
        }
        setResetYukleniyor(false);
    };

    const geriDon = () => {
        setSifreUnuttum(false);
        setResetEmail("");
        setResetGonderildi(false);
    };

    // ── Şifremi Unuttum Ekranı ──────────────────────────────
    if (sifreUnuttum) {
        return (
            <div style={styles.container}>
                <div style={styles.kart}>
                    <h1 style={styles.baslik}>📈 Borsa Analiz</h1>

                    {resetGonderildi ? (
                        <>
                            <div style={styles.basariIkon}>✉️</div>
                            <h2 style={{ ...styles.altBaslik, color: "#16a34a" }}>Mail Gönderildi!</h2>
                            <p style={styles.aciklama}>
                                <strong>{resetEmail}</strong> adresine şifre sıfırlama bağlantısı gönderildi.
                                Lütfen gelen kutunuzu (ve spam klasörünüzü) kontrol edin.
                            </p>
                            <button style={styles.buton} onClick={geriDon}>
                                ← Giriş Sayfasına Dön
                            </button>
                        </>
                    ) : (
                        <>
                            <h2 style={styles.altBaslik}>Şifremi Unuttum</h2>
                            <p style={styles.aciklama}>
                                Kayıtlı e-posta adresinizi girin. Şifre sıfırlama bağlantısı göndereceğiz.
                            </p>
                            <form onSubmit={handleResetGonder}>
                                <input
                                    style={styles.input}
                                    type="email"
                                    placeholder="E-posta adresiniz"
                                    value={resetEmail}
                                    onChange={e => setResetEmail(e.target.value)}
                                    required
                                    autoFocus
                                />
                                <button
                                    style={{ ...styles.buton, background: resetYukleniyor ? "#9ca3af" : "#2563eb" }}
                                    type="submit"
                                    disabled={resetYukleniyor}
                                >
                                    {resetYukleniyor ? "Gönderiliyor..." : "Sıfırlama Maili Gönder"}
                                </button>
                            </form>
                            <p style={styles.link}>
                                <span
                                    onClick={geriDon}
                                    style={{ color: "#2563eb", cursor: "pointer", textDecoration: "underline" }}
                                >
                                    ← Giriş sayfasına dön
                                </span>
                            </p>
                        </>
                    )}
                </div>
            </div>
        );
    }

    // ── Normal Giriş Ekranı ─────────────────────────────────
    return (
        <div style={styles.container}>
            <div style={styles.kart}>
                <h1 style={styles.baslik}>📈 Borsa Analiz</h1>
                <h2 style={styles.altBaslik}>Giriş Yap</h2>
                <form onSubmit={handleSubmit}>
                    <input
                        style={styles.input}
                        type="email"
                        placeholder="Email"
                        value={form.email}
                        onChange={e => setForm({ ...form, email: e.target.value })}
                        required
                    />
                    <input
                        style={styles.input}
                        type="password"
                        placeholder="Şifre"
                        value={form.password}
                        onChange={e => setForm({ ...form, password: e.target.value })}
                        required
                    />

                    {/* Şifremi Unuttum linki */}
                    <div style={{ textAlign: "right", marginBottom: "1rem", marginTop: "-0.5rem" }}>
                        <span
                            onClick={() => { setSifreUnuttum(true); setResetEmail(form.email); }}
                            style={styles.sifreUnuttumLink}
                        >
                            Şifremi unuttum
                        </span>
                    </div>

                    <button style={styles.buton} type="submit" disabled={yukleniyor}>
                        {yukleniyor ? "Giriş yapılıyor..." : "Giriş Yap"}
                    </button>
                </form>
                <p style={styles.link}>
                    Hesabın yok mu? <Link to="/kayit">Kayıt ol</Link>
                </p>
            </div>
        </div>
    );
}

const styles = {
    container:        { display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", background: "#f0f2f5" },
    kart:             { background: "white", padding: "2rem", borderRadius: "12px", width: "380px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" },
    baslik:           { textAlign: "center", color: "#1a1a2e", marginBottom: "0.25rem" },
    altBaslik:        { textAlign: "center", color: "#555", fontWeight: "normal", marginBottom: "1.25rem" },
    input:            { width: "100%", padding: "0.75rem", marginBottom: "1rem", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", boxSizing: "border-box" },
    buton:            { width: "100%", padding: "0.75rem", background: "#2563eb", color: "white", border: "none", borderRadius: "8px", fontSize: "16px", cursor: "pointer" },
    link:             { textAlign: "center", marginTop: "1rem", color: "#555", fontSize: "14px" },
    sifreUnuttumLink: { fontSize: "13px", color: "#2563eb", cursor: "pointer", textDecoration: "underline" },
    aciklama:         { fontSize: "13.5px", color: "#6b7280", textAlign: "center", marginBottom: "1.25rem", lineHeight: "1.6" },
    basariIkon:       { textAlign: "center", fontSize: "48px", marginBottom: "0.75rem" },
};
